import { readonly } from "vue";
import { variantsState, type Variant } from "states/variants";
import { generateColor, generateId } from "utils";

export function useVariants() {
  const variants = variantsState();

  function updateColor(id: string, color: string) {
    const index = variants.value.findIndex((v) => v.id === id);
    if (index !== -1) {
      variants.value[index].color = color;
    }
  }

  function updateName(id: string, name: string) {
    const index = variants.value.findIndex((v) => v.id === id);
    if (index !== -1) {
      variants.value[index].name = name;
    }
  }

  function deleteVariant(id: string) {
    const index = variants.value.findIndex((v) => v.id === id);
    if (index !== -1) {
      variants.value.splice(index, 1);
    }
  }

  function createVariant() {
    const newVariant: Variant = {
      id: generateId(),
      name: "Variant " + (variants.value.length + 1),
      color: generateColor(),
    };
    variants.value.push(newVariant);
  }

  return {
    variants: readonly(variants),
    updateColor,
    updateName,
    deleteVariant,
    createVariant,
  };
}
